module.exports = __webpack_public_path__ + "static/media/chat-help.a7901285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/chat-help.png
// module id = 2303
// module chunks = 0